import React, { useState, useEffect, useRef } from "react";
import Transition from "../../../../../components/Transition";
import { io } from "socket.io-client";
import { AnimatePresence } from "framer-motion";


export default function TradeCard({ setTradeMode, selectedSymbol, expert, setToastConfig }) {
    const [formData, setFormData] = useState({
        symbol: selectedSymbol?.name || null,
        tp: "0",
        sl: "0"
    });

    const [totalClients, setTotalClients] = useState(0);
    const [connectionStatus, setConnectionStatus] = useState("disconnected");

    const socketRef = useRef(null);

    const handleChange = (e) => {
        const { name, value } = e.target;

        const sound = new Audio('/assets/sounds/typing.mp3');
        sound.play();

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e, type) => {
        e.preventDefault();

        const { symbol, tp, sl } = formData;

        if (symbol && type && tp !== "" && sl !== "") {
            const data = {
                asset: symbol,
                action: type,
                price: "0",
                tp,
                sl
            };

            const sound = new Audio('/assets/sounds/trade-button.wav');
            sound.play();
            setToastConfig({ visible: true, message: `${data.action} ${data.asset} successful. Take Profit at ${data.tp} and Stop Loss at ${sl}`, type: "success" });
            socketRef.current.emit('submitTrade', data);

        } else {
            setToastConfig({ visible: true, message: "Please fill in all fields", type: "danger" });

        }
    };



    useEffect(() => {

        if (!expert) return;
        setConnectionStatus("connecting");
        socketRef.current = io("https://bot.take-profit-signals.co.za", {
            query: {
                eaCode: expert?.secret_code
            }
        });
        socketRef.current.on("totalMembers", (data) => {
            setTotalClients(data);
            setConnectionStatus("connected");
        });

        socketRef.current.on("connect_error", (err) => {
            setConnectionStatus("disconnected");
        });

    }, [expert]);

    return (
        <AnimatePresence mode="wait">
            <Transition key={selectedSymbol?.name}>
                <div className="card border-0 pb-0">
                    <div className="card-header border-0 pb-0 d-flex justify-content-between align-items-start">
                        <h2 className="card-title">{selectedSymbol?.name}</h2>
                        <div className="card-options">
                            <button className="btn btn-outline-primary btn-sm" onClick={(e) => setTradeMode(false)}>
                                <i className="fa-solid fa-arrow-left me-2"></i>
                                Back
                            </button>
                        </div>
                    </div>

                    <div className="card-body pt-0 ">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className={`badge rounded-pill px-3 py-2 fw-semibold ${connectionStatus === 'connected' ? 'bg-success' : connectionStatus === 'connecting' ? 'bg-warning text-dark' : 'bg-danger'}`}>
                                {connectionStatus === 'connected' && '🟢 Connected'}
                                {connectionStatus === 'connecting' && '🟡 Connecting...'}
                                {connectionStatus === 'disconnected' && '🔴 Disconnected'}
                            </div>
                            <div className="text-muted small">
                                {totalClients} client{totalClients === 1 ? '' : 's'} connected
                            </div>
                        </div>
                        <form>
                            <div className="form-group mb-3">
                                <label>Symbol</label>
                                <input
                                    type="text"
                                    name="symbol"
                                    value={selectedSymbol?.name}
                                    onChange={handleChange}
                                    className="form-control"
                                    readOnly
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label>Take Profit</label>
                                <input
                                    type="number"
                                    name="tp"
                                    value={formData.tp}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="1.23456"
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label>Stop Loss</label>
                                <input
                                    type="number"
                                    name="sl"
                                    value={formData.sl}
                                    onChange={handleChange}
                                    className="form-control"
                                    placeholder="1.23456"
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <button type="button" className="btn btn-success w-50" onClick={(e) => handleSubmit(e, 'BUY')}>
                                    <i className="fa fa-arrow-up me-2"></i>
                                    Buy
                                </button>
                                <button type="button" className="btn btn-danger w-50" onClick={(e) => handleSubmit(e, 'SELL')}>
                                    <i className="fa fa-arrow-down me-2"></i>
                                    Sell
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Transition>
        </AnimatePresence>
    );
}